/* Iniziali Atelier: pannello sulla scheda prodotto e aggiunta al carrello (capo + riga annidata «Iniziali Atelier").
   Dipende da lq-iniziali-core.js (window.LqIniziali). Spec: docs/superpowers/specs/2026-10-18-iniziali-atelier-design.md */
(function () {
  'use strict';

  var core = window.LqIniziali;
  if (!core || window.LqInizialiUiReady) return;
  window.LqInizialiUiReady = true;
  core.state = core.state || {};

  var OPEN_CLASS = 'lq-iniziali-open';
  var DRAG_CLOSE_PX = 80;
  var SUMMARY_LETTER_PX = 40;

  function decode(text) {
    var el = document.createElement('textarea');
    el.innerHTML = text;
    return el.value;
  }

  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  /* Il tema apre il carrello laterale solo dal suo bus interno: lo stesso effetto si ottiene con il clic sull'icona.
     All'evento «apps:product-added-to-cart» il tema ridisegna il carrello (refreshQuickCart); se era vuoto ne sostituisce
     tutto il contenuto e un'apertura arrivata prima resta invisibile. Si apre quindi appena arriva il ridisegno
     (figli diretti di contenitore ed elenco righe, non il timer della prenotazione), al più tardi dopo 2 s. */
  var QUICK_CART_MAX_WAIT_MS = 2000;
  function openQuickCart() {
    var container = document.querySelector('.quick-cart__container');
    var icon = document.querySelector('[data-js-cart-icon]');
    if (!container || !icon) return;
    var done = false;
    var timer = null;
    var observer = new MutationObserver(function () { open(); });
    function open() {
      if (done) return;
      done = true;
      observer.disconnect();
      clearTimeout(timer);
      icon.click();
    }
    observer.observe(container, { childList: true });
    var items = container.querySelector('.quick-cart__items');
    if (items) observer.observe(items, { childList: true });
    timer = setTimeout(open, QUICK_CART_MAX_WAIT_MS);
  }

  function readConfig(el) {
    var node = el.querySelector('[data-lq-iniziali-config]');
    return node ? JSON.parse(node.textContent) : null;
  }

  function productForm(el) {
    var scope = el.parentElement;
    return scope ? scope.querySelector('form[data-product-form]') : null;
  }

  /* Disegna le lettere (immagini) dentro il contenitore; letterBoxPx = altezza della lettera senza margini. */
  function drawLetters(container, text, color, config, letterBoxPx) {
    var m = config.metrics;
    var scale = letterBoxPx / (m.altezza_px - 2 * m.margine_px);
    var layout = core.layoutLetters(text, m, m.spazio_diametri, scale);
    container.textContent = '';
    container.style.width = layout.width + 'px';
    container.style.height = layout.height + 'px';
    layout.items.forEach(function (item) {
      var img = document.createElement('img');
      img.src = config.letters[item.letter + '-' + color];
      img.alt = '';
      img.style.left = item.x + 'px';
      img.style.top = item.y + 'px';
      img.style.width = item.w + 'px';
      img.style.height = item.h + 'px';
      container.appendChild(img);
    });
  }

  function Block(el) {
    this.el = el;
    this.config = readConfig(el);
    this.id = el.getAttribute('data-product-id');
    this.dialog = el.querySelector('[data-lq-dialog]');
    this.input = el.querySelector('[data-lq-input]');
    this.state = core.state[this.id] = core.state[this.id] || { initials: '', color: 'oro', point: 0, note: '', photo: false, confirmed: false };
    this.draft = core.draftFrom(this.state);
    this.pending = false;
    this.texts = {};
    var t = this.config.texts;
    for (var k in t) if (Object.prototype.hasOwnProperty.call(t, k)) this.texts[k] = decode(t[k]);
    this.bind();
    this.renderSummary();
  }

  Block.prototype.q = function (sel) { return this.el.querySelector(sel); };

  Block.prototype.bind = function () {
    var self = this;
    this.q('[data-lq-open]').addEventListener('click', function () { self.open(); });
    this.q('[data-lq-edit]').addEventListener('click', function () { self.open(); });
    this.q('[data-lq-remove]').addEventListener('click', function () { self.removeInitials(); });
    this.q('[data-lq-close]').addEventListener('click', function () { self.close(); });
    this.q('[data-lq-skip]').addEventListener('click', function () { self.removeInitials(); self.close(); });
    this.q('[data-lq-confirm]').addEventListener('click', function () { self.confirm(); });
    this.input.addEventListener('input', function () {
      var clean = core.sanitizeInitials(self.input.value);
      if (self.input.value !== clean) self.input.value = clean;
      self.draft.initials = clean;
      self.setError('[data-lq-error-initials]', '');
      self.renderPreview();
      self.updateConfirm();
    });
    Array.prototype.forEach.call(this.el.querySelectorAll('[data-lq-color]'), function (radio) {
      radio.addEventListener('change', function () { self.draft.color = radio.value; self.renderPreview(); });
    });
    Array.prototype.forEach.call(this.el.querySelectorAll('[data-lq-position]'), function (radio) {
      radio.addEventListener('change', function () { self.draft.point = Number(radio.value); self.renderPreview(); });
    });
    this.q('[data-lq-note]').addEventListener('input', function (e) { self.draft.note = e.target.value; });
    this.q('[data-lq-photo-request]').addEventListener('change', function (e) { self.draft.photo = e.target.checked; });
    this.q('[data-lq-terms]').addEventListener('change', function () {
      self.setError('[data-lq-error-terms]', '');
      self.updateConfirm();
    });
    this.dialog.addEventListener('close', function () { self.afterClose(); });
    this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.close(); });
    this.q('[data-lq-photo]').addEventListener('load', function () { self.renderPreview(); });
    this.bindDrag();
    if (this.config.points.length < 2) this.q('[data-lq-positions]').classList.add('lq-iniziali__field--single');
  };

  Block.prototype.bindDrag = function () {
    var self = this;
    var handle = this.q('[data-lq-drag]');
    var sheet = this.q('.lq-iniziali__sheet');
    var startY = null;
    handle.addEventListener('touchstart', function (e) { startY = e.touches[0].clientY; }, { passive: true });
    handle.addEventListener('touchmove', function (e) {
      if (startY === null) return;
      var dy = Math.max(0, e.touches[0].clientY - startY);
      sheet.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    handle.addEventListener('touchend', function (e) {
      if (startY === null) return;
      var dy = e.changedTouches[0].clientY - startY;
      startY = null;
      sheet.style.transform = '';
      if (dy > DRAG_CLOSE_PX) self.close();
    });
  };

  Block.prototype.open = function () {
    var cartClose = document.querySelector('.quick-cart.active .quick-cart__close-icon, .quick-cart[aria-hidden="false"] .quick-cart__close-icon');
    if (cartClose) cartClose.click();
    /* Il pannello parte sempre dallo stato confermato: le modifiche non confermate si scartano. */
    this.draft = core.draftFrom(this.state);
    this.input.value = this.draft.initials;
    this.q('[data-lq-note]').value = this.draft.note;
    this.q('[data-lq-photo-request]').checked = this.draft.photo;
    this.q('[data-lq-terms]').checked = this.state.confirmed;
    var colorRadio = this.el.querySelector('[data-lq-color][value="' + this.draft.color + '"]');
    if (colorRadio) colorRadio.checked = true;
    var posRadio = this.el.querySelector('[data-lq-position][value="' + this.draft.point + '"]');
    if (posRadio) posRadio.checked = true;
    this.updateProductPrice();
    var form = productForm(this.el);
    this.currentVariant = form ? this.variantId(form) : null;
    document.documentElement.classList.add(OPEN_CLASS);
    if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
    else this.dialog.setAttribute('open', '');
    this.renderPreview();
    this.updateConfirm();
  };

  /* Pulsante «Conferma» acceso solo con lettere + condizioni accettate (richiesta di Andrea, 19/10). */
  Block.prototype.updateConfirm = function () {
    /* Grigio ma toccabile: al tocco confirm() spiega cosa manca (richiesta di Andrea, 19/10). */
    var btn = this.q('[data-lq-confirm]');
    btn.setAttribute('aria-disabled', String(!core.canConfirm(this.draft, this.q('[data-lq-terms]').checked)));
  };

  Block.prototype.close = function () {
    if (typeof this.dialog.close === 'function' && this.dialog.open) this.dialog.close();
    else { this.dialog.removeAttribute('open'); this.afterClose(); }
  };

  Block.prototype.afterClose = function () {
    document.documentElement.classList.remove(OPEN_CLASS);
    var focusTarget = this.state.confirmed ? this.q('[data-lq-edit]') : this.q('[data-lq-open]');
    /* Il dialog ripristina il focus dopo l'evento close: si sposta al ciclo successivo. */
    if (focusTarget) setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, 0);
  };

  /* Punto con la foto del colore della variante scelta (letta all'apertura del pannello). */
  Block.prototype.pointOf = function (s) {
    return core.pointForVariant(this.config.points, this.config.colours, s.point, this.currentVariant);
  };

  Block.prototype.renderPreview = function () {
    var point = this.pointOf(this.draft);
    var photo = this.q('[data-lq-photo]');
    if (photo.getAttribute('src') !== point.foto) { photo.setAttribute('src', point.foto); return; }
    var letters = this.q('[data-lq-letters]');
    var empty = !this.draft.initials;
    this.q('[data-lq-preview-empty]').hidden = !empty;
    this.q('[data-lq-counter]').textContent = this.texts.counter.replace('__N__', this.draft.initials.length);
    if (empty || !photo.clientHeight) { letters.textContent = ''; return; }
    drawLetters(letters, this.draft.initials, this.draft.color, this.config, point.altezza * photo.clientHeight);
    letters.style.left = (point.x * 100) + '%';
    letters.style.top = (point.y * 100) + '%';
    letters.style.transform = 'translate(-50%, -50%) rotate(' + point.rotazione + 'deg)';
  };

  Block.prototype.setError = function (sel, text) {
    var node = this.q(sel);
    node.textContent = text;
    node.hidden = !text;
  };

  Block.prototype.confirm = function () {
    var ok = true;
    var firstInvalid = null;
    if (!this.draft.initials) {
      this.setError('[data-lq-error-initials]', this.texts.errorInitials);
      firstInvalid = this.input;
      ok = false;
    }
    if (!this.q('[data-lq-terms]').checked) {
      this.setError('[data-lq-error-terms]', this.texts.errorTerms);
      firstInvalid = firstInvalid || this.q('[data-lq-terms]');
      ok = false;
    }
    if (!ok) {
      firstInvalid.scrollIntoView({ block: 'center', behavior: 'instant' });
      firstInvalid.focus({ preventScroll: true });
      return;
    }
    this.setState(core.commitDraft(this.state, this.draft));
    this.close();
  };

  Block.prototype.setState = function (next) {
    this.state = core.state[this.id] = next;
    this.renderSummary();
  };

  Block.prototype.removeInitials = function () {
    this.setState({ initials: this.state.initials, color: this.state.color, point: this.state.point,
      note: this.state.note, photo: this.state.photo, confirmed: false });
  };

  Block.prototype.renderSummary = function () {
    var on = this.state.confirmed;
    this.q('[data-lq-summary]').hidden = !on;
    this.q('[data-lq-open]').hidden = on;
    this.setPriceAddon(on);
    /* Con iniziali confermate «Acquista ora» salterebbe la riga Iniziali: si nasconde. */
    var form = productForm(this.el);
    if (form) form.classList.toggle('lq-iniziali-has-initials', on);
    if (!on) return;
    var point = this.pointOf(this.state);
    this.q('[data-lq-summary-initials]').textContent = this.state.initials;
    this.q('[data-lq-summary-meta]').textContent = this.config.labels.colorName[this.state.color] + ' · ' + point.nome;
    drawLetters(this.q('[data-lq-summary-letters]'), this.state.initials, this.state.color, this.config, SUMMARY_LETTER_PX);
  };

  /* «+ 30 € Iniziali» toccabile (riapre il pannello): accanto al prezzo della pagina e, nella barra fissa, in fondo
     alla riga «colore, taglia · Cambia» (accanto al prezzo andava a capo sotto la chat). Il tema ridisegna il prezzo:
     non lo riscriviamo. */
  Block.prototype.setPriceAddon = function (on) {
    var self = this;
    var section = this.el.closest('[data-section-type], .shopify-section') || document;
    var places = section.querySelectorAll('.product__price-and-ratings .product__price, .sticky-atc-bar__meta');
    Array.prototype.forEach.call(places, function (place) {
      var inBar = place.classList.contains('sticky-atc-bar__meta');
      var box = inBar ? place : place.parentElement;
      var tag = box && box.querySelector('.lq-iniziali__price-addon');
      if (!on) { if (tag) tag.remove(); return; }
      if (!tag) {
        tag = document.createElement('button');
        tag.type = 'button';
        tag.className = 'lq-iniziali__price-addon' + (inBar ? ' fs-body-75' : '');
        tag.addEventListener('click', function () { self.open(); });
        if (inBar) place.appendChild(tag);
        else place.insertAdjacentElement('afterend', tag);
      }
      tag.textContent = self.texts.priceAddon;
    });
  };

  /* Prezzo del capo nel totale del pannello: lo span [data-price] del tema (già aggiornato alla variante scelta). */
  Block.prototype.updateProductPrice = function () {
    var section = this.el.closest('.shopify-section') || document;
    var priceNode = section.querySelector('.product__price-and-ratings [data-price]');
    var target = this.q('[data-lq-total-product]');
    if (priceNode && target && priceNode.textContent.trim()) target.textContent = priceNode.textContent.trim();
  };

  Block.prototype.variantId = function (form) {
    var input = form.querySelector('[name="id"]');
    return input ? Number(input.value) : null;
  };

  Block.prototype.addToCart = function (form, submitter) {
    var self = this;
    var variantId = this.variantId(form);
    if (!variantId) return Promise.reject(new Error('variante mancante'));
    var items;
    try {
      var additional = this.config.keepFormProperties ? core.propertiesFromEntries(Array.from(new FormData(form).entries())) : undefined;
      if (this.config.keepFormProperties) {
        var required = this.config.requiredProperties;
        if (!Array.isArray(required) || !required.length || required.some(function (key) { return !additional[key] || !additional[key].trim(); })) {
          throw new Error('Configurazione stelle incompleta');
        }
      }
      items = core.buildCartItems({
      variantId: variantId,
      initialsVariantId: this.config.initialsVariantId,
      initials: this.state.initials,
      color: this.state.color,
      note: this.state.note,
      photo: this.state.photo,
      position: this.pointOf(this.state),
      labels: this.config.labels,
      atelierId: core.newAtelierId(),
      additionalProperties: additional
      });
    } catch (error) {
      this.q('[data-lq-add-error]').hidden = false;
      return Promise.reject(error);
    }
    var prevSkip = window.upcartShouldSkipAddToCartInterceptor;
    window.upcartShouldSkipAddToCartInterceptor = true;
    if (submitter) submitter.setAttribute('aria-busy', 'true');
    function send(list) {
      return fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: list })
      });
    }
    /* Le tute due pezzi sono pacchetti (bundle): Shopify rifiuta la riga annidata con 422 e non aggiunge nulla.
       Si riprova una volta senza annidamento; le righe restano legate da _atelier_id. */
    return send(items).then(function (r) {
      return r.status === 422 ? send(core.withoutNesting(items)) : r;
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/add ' + r.status);
      return r.json();
    }).then(function (data) {
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { detail: { items: data.items } }));
      try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) { /* UpCart assente */ }
      openQuickCart();
      window.dispatchEvent(new CustomEvent('atelierInitialsAdded', { detail: { items: data.items } }));
      self.setState({ initials: '', color: 'oro', point: 0, note: '', photo: false, confirmed: false });
      self.q('[data-lq-add-error]').hidden = true;
    }).catch(function (err) {
      self.q('[data-lq-add-error]').hidden = false;
      throw err;
    }).then(function () {
      window.upcartShouldSkipAddToCartInterceptor = prevSkip;
      if (submitter) submitter.removeAttribute('aria-busy');
    }, function () {
      window.upcartShouldSkipAddToCartInterceptor = prevSkip;
      if (submitter) submitter.removeAttribute('aria-busy');
    });
  };

  /* Una sola aggiunta per volta: il doppio tocco (o pulsante + barra fissa) non aggiunge due capi. */
  Block.prototype.submit = function (form, submitter) {
    var self = this;
    var buttons = form.querySelectorAll('[data-add-to-cart]');
    this.pending = true;
    Array.prototype.forEach.call(buttons, function (btn) { btn.classList.add('loading'); });
    this.addToCart(form, submitter).catch(function () { /* messaggio già mostrato */ }).then(function () {
      self.pending = false;
      Array.prototype.forEach.call(buttons, function (btn) { btn.classList.remove('loading'); });
    });
  };

  var blocks = [];

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-lq-iniziali]'), function (el) {
      if (el.__lqIniziali) return;
      el.classList.add('lq-iniziali--ready');
      el.__lqIniziali = new Block(el);
      blocks.push(el.__lqIniziali);
      window.dispatchEvent(new CustomEvent('atelierInitialsReady', { detail: { productId: el.getAttribute('data-product-id') } }));
    });
  }

  /* Fase di cattura: interviene prima del form del tema, solo se le iniziali sono confermate. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-product-form]')) return;
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      if (!document.body.contains(block.el)) continue;
      if (productForm(block.el) !== form) continue;
      var decision = core.submitDecision({
        confirmed: block.state.confirmed, initials: block.state.initials,
        pending: block.pending, variantId: block.variantId(form)
      });
      if (decision === 'pass') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (decision === 'block') return;
      block.submit(form, e.submitter);
      return;
    }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  /* Il tema può ridisegnare la colonna prodotto al cambio variante: inizializza i blocchi nuovi (lo stato resta per prodotto). */
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (document.querySelector('[data-lq-iniziali]:not(.lq-iniziali--ready)')) init();
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
